<template>
  <v-snackbar
    style="top: 1rem"
    class="white-break"
    v-model="snackbar.visible"
    :color="snackbar.color"
    :top="snackbar.top"
  >
    {{ snackbar.msg }}
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["snackbar"])
  },
  methods: {
    close() {
      this.$store.commit("snackbar/CLOSE_SNACKBAR");
    }
  }
};
</script>
<style lang="sass" scoped>
.white-break
  white-space: pre-line
</style>
